(() => {
  const initReviews = () => {
    const root = document.querySelector('#aw31-family-reviews');
    if (!root || root.dataset.aw31PaginationReady === 'true') return;
    root.dataset.aw31PaginationReady = 'true';

    const badReviewPatterns = [
      /all[-\s]?terrain\s+design/i,
      /\bcane\b/i,
      /James\s+Keith/i,
      /Mike\s+Hackney/i,
      /Cecil\s+Feil/i,
      /Israel\s+Ballesteros/i,
      /\bExcelente\b/i,
      /\bIts\s+great\b/i,
      /Parkinson/i
    ];

    root.querySelectorAll('[data-aw31-review-card]').forEach((card) => {
      const text = (card.textContent || '').replace(/\s+/g, ' ').trim();
      if (badReviewPatterns.some((re) => re.test(text))) {
        card.remove();
      }
    });

    const cards = [...root.querySelectorAll('[data-aw31-review-card]')];
    const pageSize = 6;
    const pager = root.querySelector('.aw31-review-pagination');
    const totalPages = Math.max(1, Math.ceil(cards.length / pageSize));

    if (!pager) return;
    pager.innerHTML = '';
    for (let i = 1; i <= totalPages; i += 1) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.aw31Page = String(i);
      button.textContent = String(i);
      button.setAttribute('aria-label', `Show review page ${i}`);
      pager.appendChild(button);
    }
    pager.hidden = totalPages <= 1;

    const render = (page) => {
      const safePage = Math.min(Math.max(Number(page) || 1, 1), totalPages);
      const start = (safePage - 1) * pageSize;
      cards.forEach((card, index) => {
        const show = index >= start && index < start + pageSize;
        card.hidden = !show;
        card.style.display = show ? '' : 'none';
      });
      pager.querySelectorAll('[data-aw31-page]').forEach((button) => {
        const active = Number(button.dataset.aw31Page) === safePage;
        button.classList.toggle('is-active', active);
        if (active) button.setAttribute('aria-current', 'page');
        else button.removeAttribute('aria-current');
      });
    };

    pager.addEventListener('click', (event) => {
      const button = event.target.closest('[data-aw31-page]');
      if (!button) return;
      event.preventDefault();
      render(Number(button.dataset.aw31Page));
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    render(1);
  };

  const initLightbox = () => {
    const lightbox = document.querySelector('#aw31-review-lightbox');
    if (!lightbox || lightbox.dataset.aw31Ready === 'true') return;
    lightbox.dataset.aw31Ready = 'true';
    const img = lightbox.querySelector('[data-aw31-lightbox-img]') || lightbox.querySelector('.aw31-lightbox-image');
    const close = () => {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      if (img) img.removeAttribute('src');
      document.documentElement.classList.remove('aw31-lightbox-open');
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-aw31-lightbox-src]');
      if (trigger && img) {
        event.preventDefault();
        event.stopPropagation();
        img.src = trigger.dataset.aw31LightboxSrc || (trigger.querySelector && trigger.querySelector('img') ? trigger.querySelector('img').src : trigger.src);
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('aw31-lightbox-open');
      }
      if (event.target.closest('[data-aw31-lightbox-close]')) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) close();
    });
  };

  const run = () => { initReviews(); initLightbox(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
})();
